import minusZeroImg from '@/assets/images/minus_zero1.webp'
import Translatable from '@/components/translatable_text/Translatable';
function ServiceIntro() {
  return (
    <section className="py-16 md:py-24x d-rotate wow">
      <div className="container ">
        <div className="info mb-16 md:mb-20 lg:mb-32 pb-8 md:pb-12 border-b border-gray-300">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="item mb-8 md:mb-12 rotate-text">
              <span className="block opacity-80 mb-2 text-sm md:text-base"><Translatable>Category :</Translatable></span>
              <h6 className="text-lg md:text-xl font-semibold"><Translatable>Development</Translatable></h6>
            </div>
            <div className="item mb-8 md:mb-12 rotate-text">
              <span className="block opacity-80 mb-2 text-sm md:text-base"><Translatable>Founder :</Translatable></span>
              <h6 className="text-lg md:text-xl font-semibold"><Translatable>SolData</Translatable></h6>
            </div>
            <div className="item rotate-text">
              <span className="block opacity-80 mb-2 text-sm md:text-base"><Translatable>Operation :</Translatable></span>
              <h6 className="text-lg md:text-xl font-semibold"><Translatable>GCAD</Translatable></h6>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col justify-center ">
          <div>
            <h4 className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold"><Translatable>Every great transformation begins with a question:</Translatable></h4>
            <p className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-3xl font-light"><Translatable>How does intelligence become a true driver of decisions, growth, and impact?</Translatable>
            </p>
          </div>
          <div className="w-full lg:w-11/12 pt-20">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
              <div className="lg:col-span-5">
                <h4 className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold"><Translatable>The Story</Translatable></h4>
              </div>
              <div className="lg:col-span-7">
                <div className="text">
                  <p className="text-base md:text-lg lg:text-xl leading-relaxed rotate-text">
                    <Translatable>At GCAD, this question sparked our specialized AI unit—built to transform data into understanding and intelligence into measurable value.</Translatable>
                  </p>
                  <br/>
                  <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    <span className=" font-medium"><Translatable>Our vision was clear:</Translatable></span>
                    <Translatable>We bridge the gap between advanced AI research and practical business solutions. Our focus isn't technology for its own sake, but intelligent systems designed to solve real problems and deliver real results.</Translatable>
                  </p>
                  <br/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="img overflow-hidden rounded-lg py-20">
          <img 
            src={'https://images.unsplash.com/photo-1727434032765-9c4df88b6e02?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
            alt="" 
            className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-lg"
          />
        </div>

        <div className="flex flex-col justify-center">
          <div className="pt-120">
            <h4 className="mb-20 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold"><Translatable>Minus zero</Translatable></h4>
            <p className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-3xl font-light"><Translatable>In a rapidly evolving Saudi workforce, potential is everywhere — but understanding it accurately is the real challenge.</Translatable></p>
          </div>
          <div className="w-full lg:w-11/12 pt-20 rotate-text">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
              <div className="lg:col-span-5">
                <h4 className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold"><Translatable>The Story</Translatable></h4>
              </div>
              <div className="lg:col-span-7">
                <div className="text">
                  <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    <Translatable>Minus Zero was created to help individuals see themselves more clearly. Designed as a Saudi Arabic chatbot, it focuses on measuring productivity and evaluating academic and professional capabilities through intelligent analysis of personal abilities. Its goal is simple yet powerful: turn self-assessment into actionable insight.</Translatable>
                  </p>
                  <br/>
                  <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    <Translatable>Minus Zero bridges ambition with clarity — empowering individuals to develop their performance, shape their career paths, and contribute more effectively to the future of work in Saudi Arabia.</Translatable>
                  </p>
                  <div className="row">
                    <br/>
                    <a style={{ color: 'red'}} target='_blank' className="text-base underline md:text-lg lg:text-xl leading-relaxed" href='https://www.solutiondata.org/blog'>
                      <Translatable>Minus zero -- website</Translatable>
                    </a>
                </div>
              </div>
            </div>
          </div>
          <div className="img overflow-hidden rounded-lg py-20">
            <img 
              src={minusZeroImg}
              alt="" 
              className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-lg"
            />
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceIntro;
